import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  isAuthenticatedGuard,
  isNotAuthenticatedGuard,
} from 'src/shared/guards';

const routes: Routes = [
  {
    path: 'sign-in',
    canActivate: [isNotAuthenticatedGuard],
    loadComponent: () => import('./pages/login-page/login-page.component').then(m => m.LoginPageComponent),
  },
  {
    path: '',
    canActivate: [isAuthenticatedGuard],
    loadComponent: () => import('./pages/master-page/master-page.component').then(m => m.MasterPageComponent),
    children: [
      {
        path: 'home',
        loadChildren: () => import('./pages/home/home-routing.module').then(m => m.HomeRoutingModule),
      },
      {
        path: 'foot-traffic',
        loadChildren: () => import('./pages/foot-traffic/foot-traffic-routing.module').then(m => m.FootTrafficRoutingModule),
      },
      {
        path: 'vehicular-traffic',
        loadChildren: () => import('./pages/vehicular-traffic/vehicular-traffic-routing.module').then(m => m.VehicularTrafficRoutingModule),
      },
      {
        path: 'pedestrian-flow',
        loadChildren: () => import('./pages/pedestrian-flow/pedestrian-flow-routing.module').then(m => m.PedestrianFlowRoutingModule),
      },
      {
        path: 'configuration',
        loadChildren: () => import('./pages/configuration/configuration-routing.module').then(m => m.ConfigurationRoutingModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard-routing.module').then(m => m.DashboardRoutingModule),
      },
       {
        path: 'vehicular-traffic',
        loadChildren: () => import('./pages/vehicular-traffic/vehicular-traffic-routing.module').then(m => m.VehicularTrafficRoutingModule),
      },
      {
        path: 'analytics',
        loadChildren: () => import('./pages/analytics/analytics-routing.module').then(m => m.AnalyticsRoutingModule),
      },
      {
        path: 'administrator',
        loadChildren: () => import('./pages/administrator/administrator-routing.module').then(m => m.AdministratorRoutingModule),
      },
      { path: '', redirectTo: '/home', pathMatch: 'full' },
    ]
  },
  { path: '**', redirectTo: '/sign-in', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})

export class AppRoutingModule {}
